import { useField } from 'formik'

const HoneypotField = ({ name }) => {
  const [field] = useField({ name })

  return (
    <input
      {...field}
      type='text'
      tabIndex={-1}
      autoComplete='off'
      aria-hidden='true'
      style={{ display: 'none' }}
    />
  )
}

export default HoneypotField 